var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAttentionYellow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16.057,
    viewBox: "0 0 18 16.057",
    fill: "#f8b131",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.76,26.683l-7.23-12.522a1.768,1.768,0,0,0-3.062,0L.24,26.683a1.768,1.768,0,0,0,1.531,2.652H16.23a1.768,1.768,0,0,0,1.531-2.652ZM9,27.3a1.151,1.151,0,1,1,1.151-1.151A1.152,1.152,0,0,1,9,27.3Zm1.158-4.918a1.158,1.158,0,1,1-2.317,0V17.062a.549.549,0,0,1,.549-.549H9.61a.549.549,0,0,1,.549.549v5.317Z",
    transform: "translate(0 -13.277)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttentionYellow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attention-yellow.5fd4cf67.svg";
export { ForwardRef as ReactComponent };